<template>
    <div>
        <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="4">
                &nbsp;
                <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true" v-if="$isFullAdmin">{{$t('common.create')}}</el-button>
                <el-button :loading="exporting" icon="el-icon-download" @click="download" v-if="$isAdmin">{{$t('common.export')}}</el-button>
            </el-col>
            <el-col :span="4">
                <country-selector clearable v-model="filter.countryId"></country-selector>
            </el-col>
            <el-col :span="3">
                <el-input v-model="filter.city" prefix-icon="el-icon-search" :placeholder="$t('common.city')"></el-input>
            </el-col>
            <el-col :span="3">
                <el-input v-model="filter.zip" prefix-icon="el-icon-search" :placeholder="$t('common.zip')"></el-input>
            </el-col>
            <el-col :span="4">
                <chain-selector v-model="filter.chainId"></chain-selector>
            </el-col>
            <el-col :span="3">
                <el-input v-model="filter.text" prefix-icon="el-icon-search" :placeholder="$t('common.name')"></el-input>
            </el-col>
            <el-col :span="3">
                <el-input v-model="filter.state" prefix-icon="el-icon-search" :placeholder="$t('common.state')"></el-input>
            </el-col>
        </el-row>
        <el-table size="mini" :data="customers" @sort-change="sortChanged" @expand-change="expanded" v-loading="loading" class="orders-table tablewithshading">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-table size="mini" :data="customerEquipment[props.row.id]" class="tablewithshading" v-if="customerEquipment[props.row.id] && customerEquipment[props.row.id].length > 0">
                        <el-table-column prop="model" :label="$t('common.model')"></el-table-column>
                        <el-table-column prop="serialNumber" :label="$t('common.serialNumber')"></el-table-column>
                        <el-table-column prop="warrantyStart" :label="$t('common.warrantyStart')">
                            <template slot-scope="scope">
                                {{scope.row.warrantyStart | date}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="warrantyEnd" :label="$t('common.warrantyEnd')">
                            <template slot-scope="scope">
                                {{scope.row.warrantyEnd | date}}
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-alert :closable="false" :title="$t('masters.customerHasNoEquipment')" v-if="!customerEquipment[props.row.id] || customerEquipment[props.row.id].length === 0" type="info"></el-alert>
                </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="no" :label="$t('common.number')"></el-table-column>
            <el-table-column sortable="custom" prop="name" :label="$t('common.name')"></el-table-column>
            <el-table-column prop="country" :label="$t('common.country')"></el-table-column>
            <el-table-column :label="$t('common.phone')">
                <template slot-scope="scope">
                    <a :href="'callto:'+scope.row.phone">{{scope.row.phone}}</a>
                </template>
            </el-table-column>
            <el-table-column :label="$t('common.operations')" fixed="right" :width="$isSuperAdmin ? 160 : 116 + 'px'">
                <template slot-scope="scope">
                    <el-button size="mini" @click="editCustomer(scope.row.id)">
                        <i class="el-icon-edit"></i>
                    </el-button>
                    <el-button size="mini" type="danger" @click="deleteCustomer(scope.row.id)" v-if="$isSuperAdmin">
                        <i class="el-icon-delete"></i>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pager" v-if="total !== 0" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="15" layout="total, prev, pager, next" :total="total">
        </el-pagination>
        <create-update-customer-dialog :customerId="customerToEdit" :visible="dialogVisible" @dialogClosed="editFinished" @save="appendCustomer"></create-update-customer-dialog>
    </div>
</template>

<script>
import Vue from "vue";
import CreateUpdateCustomerDialog from "./CreateUpdateCustomerDialog";
import ChainSelector from "./ChainSelector";
import { CountrySelector } from "@/app/shared/components";
import api from "../api";

export default {
  name: "customer-list",
  components: {
    CreateUpdateCustomerDialog,
    CountrySelector,
    ChainSelector
  },
  data() {
    return {
      customers: [],
      customerEquipment: [],
      loading: true,
      exporting: false,
      dialogVisible: false,
      customerToEdit: undefined,
      filter: {
        countryId: undefined,
        chainId: undefined,
        text: undefined,
        city: undefined,
        zip: undefined,
        state: undefined
      },
      sort: undefined,
      currentPage: 1,
      total: 0
    };
  },
  created() {
    this.loadCustomers();
  },
  watch: {
    filter: {
      deep: true,
      handler: function(val) {
        this.loadCustomers();
      }
    }
  },
  methods: {
    download() {
      this.exporting = true;
      api.download(this.filter, this.sort).then(() => {
        this.exporting = false;
      });
    },
    sortChanged(sort) {
      this.sort = sort;
      if (this.currentPage === 1) {
        this.loadCustomers();
      } else {
        this.currentPage = 1;
      }
    },
    expanded(row, expandedRows) {
      let isExpanded = expandedRows.indexOf(row);
      if (isExpanded !== -1) {
        api.getEquipment(row.id).then(response => {
          Vue.set(this.customerEquipment, row.id, response.data);
          //[row.id] = response.data;
        });
      }
    },
    loadCustomers() {
      this.loading = true;
      api
        .getCustomers(
          this.currentPage,
          this.filter.countryId,
          this.filter.chainId,
          this.filter.text,
          this.filter.city,
          this.filter.zip,
          this.filter.state,
          this.sort,
          ""
        )
        .then(response => {
          this.loading = false;
          this.customers = response.data.items;
          this.total = response.data.total;
        });
    },
    appendCustomer(event) {
      this.loadCustomers();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadCustomers();
    },
    editCustomer(id) {
      this.customerToEdit = id;
      this.dialogVisible = true;
    },
    editFinished() {
      this.customerToEdit = null;
      this.dialogVisible = false;
    },
    deleteCustomer(id) {
        this.$confirm(this.$t('common.thisWillDeleteCustomerContinue'), "Warning", {
        confirmButtonText: this.$t('common.OK'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      })
        .then(() => {
          api.deleteCustomer(id).then(() => {
            this.loadCustomers();
            this.$message({
              type: "success",
              message: this.$t('common.deleteCompleted')
            });
          });
        })
        .catch(_ => {});
    }
  }
};
</script>



// WEBPACK FOOTER //
// ClientApp/app/masters/customers/components/CustomerList.vue